import React, { ReactElement } from 'react'

import currencyUtils from '@lib/currency'

export interface Props {
  currency: string
  value: number
  locale?: Locale
}

export const Currency = ({ currency, value, locale }: Props): ReactElement => {
  const formattedValue = currencyUtils.create(value, currency as Currency, { locale }).format()
  return <span>{formattedValue}</span>
}
